import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { useTenant } from '@/contexts/TenantContext';

/**
 * Breadcrumb trail. `items` is an array like [{label, to}]. The last item is rendered
 * as plain text (current page).
 */
export default function Breadcrumbs({ items = [] }) {
  const { tenantPath } = useTenant();
  if (!items.length) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="mb-6 text-sm text-gray-500"
      data-testid="breadcrumbs"
    >
      <ol className="flex flex-wrap items-center gap-1">
        <li>
          <Link
            to={tenantPath('/')}
            className="hover:text-gray-900 transition-colors"
          >
            Home
          </Link>
        </li>
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              <ChevronRight className="w-3.5 h-3.5 text-gray-300" />
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-gray-900 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-700 font-medium line-clamp-1 max-w-xs">
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
